var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBoxCheck = function SvgBoxCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#17488A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M26.667 26.666 30 30l6.666-6.667"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#17488A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M35 16.667v-3.334a3.33 3.33 0 0 0-1.667-2.883L21.667 3.784a3.33 3.33 0 0 0-3.334 0L6.667 10.45A3.33 3.33 0 0 0 5 13.334v13.333a3.33 3.33 0 0 0 1.667 2.883l11.666 6.667a3.33 3.33 0 0 0 3.334 0l3.333-1.9M12.5 7.116l15 8.584"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#17488A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.483 11.667 20 20l14.517-8.333M20 36.667V20"
  })));
};
export default SvgBoxCheck;